module.exports = "/_next/static/images/6e303ea9f770a7c36834293d40f25644-girl-holding-card-landing@lg.jpg.webp";